export enum ErrorType {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  UNKNOWN = 'UNKNOWN',
}

export interface Error {
  errorMessage: string;
  errorType: ErrorType;
}

export const SELECTED_MEMBERSHIP_LEVEL_URL_QUERY_PARAM = 'selectedMembershipLevel';
export const SELECTED_MEMBERSHIP_TERM_URL_QUERY_PARAM = 'selectedTerm';
